// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  List,
  Avatar,
  Button,
  Collapse,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
} from '@mui/material';
// components
import Iconify from 'src/minimals/components/Iconify';
import Scrollbar from 'src/minimals/Scrollbar';
import BadgeStatus from 'src/minimals/components/BadgeStatus';
//
import ChatRoomPopup from './ChatRoomPopup';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

const HEIGHT = 64;

const CollapseButtonStyle = styled(Button)(({ theme }) => ({
  ...theme.typography.overline,
  height: 40,
  borderRadius: 0,
  padding: theme.spacing(1, 2),
  justifyContent: 'space-between',
  color: theme.palette.text.disabled,
}));

export default function ChatRoomGroupParticipant({
  participants,
  selectUserId,
  onShowPopupUserInfo,
  isCollapse,
  onCollapse,
}) {
  const { t } = useTranslation();

  return (
    <>
      <CollapseButtonStyle
        fullWidth
        disableRipple
        color="inherit"
        onClick={onCollapse}
        endIcon={
          <Iconify
            icon={
              isCollapse
                ? 'eva:arrow-ios-downward-fill'
                : 'eva:arrow-ios-forward-fill'
            }
            width={16}
            height={16}
          />
        }
      >
        {t('chat.group_total_participants')} ({participants.length})
      </CollapseButtonStyle>

      <Box sx={{ height: isCollapse ? HEIGHT * 4 : 0 }}>
        <Scrollbar>
          <Collapse
            in={isCollapse}
            sx={{ height: isCollapse ? HEIGHT * 4 : 0 }}
          >
            <List disablePadding>
              {participants.map((participant) => (
                <Participant
                  key={participant.id}
                  participant={participant}
                  isOpen={selectUserId === participant.id}
                  onShowPopup={() => onShowPopupUserInfo(participant.id)}
                  onClosePopup={() => onShowPopupUserInfo(null)}
                />
              ))}
            </List>
          </Collapse>
        </Scrollbar>
      </Box>
    </>
  );
}

function Participant({ participant, isOpen, onClosePopup, onShowPopup }) {
  const { t } = useTranslation();
  const user = useSelector((state) => state.user);
  const { name, profilePicture, status, position } = participant;

  const displayName =
    user.id === participant.id ? `${name} (${t(`chat.self_user_name`)})` : name;

  return (
    <>
      <ListItemButton onClick={onShowPopup} sx={{ height: HEIGHT, px: 2.5 }}>
        <ListItemAvatar>
          <Box sx={{ position: 'relative', width: 40, height: 40 }}>
            <Avatar alt={name} src={profilePicture} />
            <BadgeStatus
              status={status}
              sx={{ right: 0, bottom: 0, position: 'absolute' }}
            />
          </Box>
        </ListItemAvatar>
        <ListItemText
          primary={displayName}
          secondary={position}
          primaryTypographyProps={{ variant: 'subtitle2', noWrap: true }}
          secondaryTypographyProps={{ noWrap: true }}
        />
      </ListItemButton>
      <ChatRoomPopup
        participant={participant}
        isOpen={isOpen}
        onClose={onClosePopup}
      />
    </>
  );
}
